import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  profile: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  nickname: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space8,
  },
}));
